module.exports = __webpack_public_path__ + "img/api.0f688871.svg";